/**
 * Presentment-currency formatting + market cookie sync (loaded before common.js).
 */
(function () {
  var CURRENCY_LOCALES = { USD: 'en-US', CAD: 'en-CA', GBP: 'en-GB', AUD: 'en-AU', EUR: 'en-GB' };
  var COUNTRY_CURRENCY = { GB: 'GBP', CA: 'CAD', US: 'USD' };

  function getActiveCurrencyCode() {
    var fromShopify = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (fromShopify) return String(fromShopify).toUpperCase();

    var fromKulfi = window.kulfiMarket && window.kulfiMarket.currency;
    if (fromKulfi) return String(fromKulfi).toUpperCase();

    var country = (
      (window.kulfiMarket && (window.kulfiMarket.localizationCountry || window.kulfiMarket.country)) ||
      (document.body && document.body.dataset && document.body.dataset.shopCountry) ||
      ''
    ).toUpperCase();

    if (country && COUNTRY_CURRENCY[country]) return COUNTRY_CURRENCY[country];
    return 'USD';
  }

  function parseCents(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var amount = Number(cents);
    return Number.isFinite(amount) ? amount : null;
  }

  function stripTrailingZeroCents(formatted) {
    return String(formatted)
      .replace(/(\.|,)00(?!\d)/, '')
      .replace(/(\.|,)00$/, '');
  }

  function formatWithIntl(cents) {
    var amount = parseCents(cents);
    if (amount == null) return '';

    var currency = getActiveCurrencyCode();
    var locale = CURRENCY_LOCALES[currency] || 'en-US';

    try {
      var formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(amount / 100);

      return stripTrailingZeroCents(formatted);
    } catch (e) {
      return '';
    }
  }

  window.kulfiFormatMoney = function (cents) {
    return formatWithIntl(cents) || null;
  };

  window.kulfiFormatMoneyWithoutTrailingZeros = function (cents) {
    return formatWithIntl(cents) || null;
  };

  function initKulfiMarketSync() {
    var cookieMatch = document.cookie.match(/(?:^|;\s*)kulfi_market=([^;]*)/);
    if (!cookieMatch) return;

    var desiredCountry = decodeURIComponent(cookieMatch[1]).trim().toUpperCase();
    if (desiredCountry !== 'US' && desiredCountry !== 'CA' && desiredCountry !== 'GB') return;

    var currentCountry = (
      (window.kulfiMarket && window.kulfiMarket.localizationCountry) ||
      (document.body && document.body.dataset && document.body.dataset.shopCountry) ||
      ''
    ).toUpperCase();

    if (!currentCountry || desiredCountry === currentCountry) return;

    var syncKey = 'kulfi_market_sync_' + desiredCountry;
    if (sessionStorage.getItem(syncKey)) return;

    sessionStorage.setItem(syncKey, '1');

    fetch('/localization', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new URLSearchParams({
        country_code: desiredCountry,
        return_to: window.location.pathname + window.location.search,
      }),
    })
      .then(function (res) {
        if (res.ok) window.location.reload();
        else sessionStorage.removeItem(syncKey);
      })
      .catch(function () {
        sessionStorage.removeItem(syncKey);
      });
  }

  initKulfiMarketSync();
})();
